﻿$.fn.dxCtrlFichierJointEmail2 = function custom_dxCtrlFichierJointEmail2(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlfichierjointemail2 dx-ctrl");
        this.createInstance(new cdxCtrlFichierJointEmail2(this, option));
    }
    return this;
}

window.cdxCtrlFichierJointEmail2 = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = []

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.containerViewer == 'undefined') option.containerViewer = $("body")

    var isDirty = false
    this.isDirty = function (value) {
        if (typeof value != 'undefined') isDirty = value
        return isDirty
    }
    var $DivLstFiles = null
    var dxBtAddFile = null
    var widthItem = 150
    function mConstruit() {
        container.empty();
        container.css("position", "relative")
        container.css("font-family", "Barlow Condensed")
        container.css("padding", "2px")
        if (option.readOnly) container.css("opacity", "0.5")
        if (option.readOnly) container.css("font-style", "italic")

        container.addClass("state-hover")
        container.on("click", function () {
            Me.mAddFile(null)
        })
        if (!option.readOnly) {
            dxBtAddFile = $("<div/>").appendTo(container).dxCtrlButton({
                height: 40,
                width: 40,
                icon: "fas fa-paperclip",
                icon2: "fas fa-plus",
                txtTooltip: "Ajouter des fichiers",
                onClick: function (e) {
                    e.event.stopPropagation()
                    Me.mAddFile()
                }
            }).dxCtrlButton("instance")
            if (option.dataSource.length > 0) dxBtAddFile.element().hide()
        }
        $DivLstFiles = $("<div/>").appendTo(container)

        var nb = Math.floor($DivLstFiles.width() / 150)
        var relicat = $DivLstFiles.width() - nb * 150
        if (nb > 0) relicat = Math.floor(relicat / nb)
        widthItem = 150 + relicat
        resizeObserver.mAdd($DivLstFiles, function () {
            var nb = Math.floor($DivLstFiles.width() / 150)
            var relicat = $DivLstFiles.width() - nb * 150
            if (nb > 0) relicat = Math.floor(relicat / nb)
            widthItem = 150 + relicat
            $DivLstFiles.find(".itemfile").css("width", (widthItem - 18) + 'px')
        });

        mRempli()
    }

    var lstDivFile = []
    function mRempli() {
        $DivLstFiles.empty()
        lstDivFile = []
        option.dataSource.forEach(function (file, idx) {
            mAddItem(file)
        })
    }
    function mAddItem(file) {
        var fileTrait = file
        var fileName = fileTrait.substring(fileTrait.lastIndexOf("/") + 1)
        var $DivFile = $("<div style='cursor:pointer;width:" + (widthItem - 18) + "px;margin:3px;padding:5px;display:inline-block;border-radius:5px;border:" + theme.border + ";' title='" + fileName.replace(/'/g, '&#39;') + "' class='itemfile'></div>").appendTo($DivLstFiles)
        $DivFile.on("mouseenter", function (e) { container.removeClass("state-hover") })
        $DivFile.on("mouseleave", function (e) { container.addClass("state-hover") })
        lstDivFile.push($DivFile)
        //if (!option.readOnly) {
        $DivFile.addClass("state-hover")
        $DivFile.on("click", function (e) {
            e.stopPropagation()
            Me.mAddFile()
        })
        //}
        var $Table = $("<table style='width:100%;height:100%;height:22px;table-layout: fixed;'/>").appendTo($DivFile)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdFile = $("<td style='width:20px;text-align:center;'/>").appendTo($Tr)
        if (fileTrait.startsWith("~")) fileTrait = fileTrait.substring(1)
        var fic = new cFichier(option.bddCtrl,fileTrait)
        fic.mGetElementImage(20, 20).appendTo($TdFile)
        var $TdFile = $("<td style='width:calc(100% - 20px);white-space:nowrap;overflow-x:hidden;text-overflow:ellipsis;padding-left:5px;'>" + fileName + "</td>").appendTo($Tr)
        if (!option.readOnly && typeof option.onDelete != "undefined") {
            var $TdFile = $("<td style='width:26px;'></td>").appendTo($Tr)
            $("<div style='color:" + theme.backgroundcolorAccent + ";'/>").appendTo($TdFile).dxCtrlButtonImage({
                icon: "fas fa-window-close",
                txtTooltip: "Supprimer le fichier joint",
                padding: 2,
                fontSize: 18,
                onClick: function (e) {
                    isDirty = true
                    e.stopPropagation()
                    $DivFile.remove()
                    option.dataSource.splice(option.dataSource.indexOf(file), 1)
                    option.onDelete(file)
                }
            })
        }
    }

    function mOpenDetailFile(urlFile) {
        Me.mGetFichierVisu(urlFile).show()
    }

    var dataSourceFichierVisu = []
    this.mGetFichierVisu = function (urlFile) {
        if (typeof urlFile == 'undefined') urlFile=null
        dataSourceFichierVisu = []
        var selectedItem = null
        option.dataSource.forEach(function (fileIdx, idx) {
            dataSourceFichierVisu.push({
                urlFile: fileIdx,
                nameFile: fileIdx.substring(fileIdx.lastIndexOf("/") + 1),
                item: fileIdx
            })
            if (urlFile == null) { selectedItem = dataSourceFichierVisu[0] }
            else if (fileIdx == urlFile) { selectedItem = dataSourceFichierVisu[dataSourceFichierVisu.length - 1] }
        })

        var opt = {
            bddCtrl: option.bddCtrl,
            dataSource: dataSourceFichierVisu,
            readOnly: option.readOnly,
            selectedItem: selectedItem,
            onClose: function () { },
            containerViewer: option.containerViewer,
            allowDisplayIcone: option.allowDisplayIcone
        }
        if (!option.readOnly) {
            opt.onAddNewFiles = function (lstFile, funcFin) {
                mSaveTableFichier(0)
                function mSaveTableFichier(idx) {
                    if (typeof lstFile[idx] != 'undefined') {
                        option.dataSource.push(lstFile[idx].url)
                        dataSourceFichierVisu.push({
                            urlFile: lstFile[idx].url,
                            nameFile: lstFile[idx].url.substring(lstFile[idx].url.lastIndexOf("/") + 1),
                            item: lstFile[idx].url
                        })
                        mAddItem(lstFile[idx].url)
                        mSaveTableFichier(idx + 1)
                    } else {
                        //le dataSource a changé
                        //le dernier item à sélectionné est à la fin
                        var selectedItem = dataSourceFichierVisu[dataSourceFichierVisu.length - 1]
                        if (option.dataSource.length > 0) { dxBtAddFile.element().hide() }
                        else { dxBtAddFile.element().show() }
                        if (typeof option.onAdd != 'undefined') option.onAdd()
                        funcFin(selectedItem)
                        isDirty = true
                    }
                }
            }
            opt.onDeleteFiles = function (lstUrlFile, funcFin) {
                lstUrlFile.forEach(function (urlFile) {
                    var idxDel = option.dataSource.indexOf(urlFile)
                    option.dataSource.splice(idxDel, 1)
                    dataSourceFichierVisu.splice(idxDel, 1)
                    var $DivFileDel = lstDivFile[idxDel]
                    lstDivFile.splice(idxDel, 1)
                    $DivFileDel.remove()
                })
                isDirty = true
                if (option.dataSource.length > 0) { dxBtAddFile.element().hide() }
                else { dxBtAddFile.element().show() }
                if (typeof option.onDelete != 'undefined') option.onDelete()
                funcFin()
            }
            opt.onChange = function () { isDirty = true }
        }
        return $("<div/>").appendTo("body").dxCtrlFichierVisu(opt).dxCtrlFichierVisu("instance")
    }

    this.mAddFile = function (urlFile) {
        var dxFichierVisu = Me.mGetFichierVisu(urlFile)
        if (option.dataSource.length == 0) {
            dxFichierVisu.popup.show()
            dxFichierVisu.popup.hide()
            dxFichierVisu.mPerformClickAddFile()
        } else { dxFichierVisu.popup.show() }
    }

    this.mAddFiles = function (lstUrlFile) {
        lstUrlFile.forEach(function (urlFile) {
            option.dataSource.push(urlFile)
            mAddItem(urlFile)
        })
        isDirty = true
    }

    this.mClearFiles = function () {
        option.dataSource=[]
        mRempli()
        isDirty = true
    }
    //this.mClearFile = function () {
    //    isDirty = true
    //    while (option.dataSource.length > 0) { option.dataSource.splice(0, 1) }
    //    mRempli()
    //    option.onDelete()
    //    if (option.dataSource.length > 0) { dxBtAddFile.element().hide() }
    //    else { dxBtAddFile.element().show() }
    //}

    //this.mAddFiles = function (lstFile) {
    //    isDirty = true
    //    lstFile.forEach(function (file) { option.dataSource.push(file) })
    //    mRempli()
    //    if (typeof option.onAdd != "undefined") option.onAdd(lstFile)
    //}

    this.element = function () { return container }

    mConstruit();
}